import { useWatch } from 'react-hook-form'

import { useFormError } from './useFormError'

export const useIsFieldInvalid = (name: string): boolean => {
  const error = useFormError(name)
  const value = useWatch({ name })
  return error != null && value != null
}
